import { CommissionProfile } from './commissionProfile.model';

export class Supplier {
  id!: number;
  name!: string;
  reference!: string;
  ownerId!: string;
  supplierOrchestra!: string;
  supplierPulpo!: string;
  supplierPulpoId!: number;
  supplierTravelexchange: string;
  isB2b2c!: boolean;
  active!: boolean;
  profile!: CommissionProfile;
  agencyCount!: number;
  removable!: boolean;
  refDistri!: string;
}
